import { useState } from "react";

import { restProvider } from "@/api/rest";
import { InlineError } from "@/components/ui/InlineError";
import { ButtonLoader } from "@/components/ui/buttons/ButtonLoader";
import { TextInput } from "@/components/ui/formControls";
import { hasMessage, oauth2ErrorDescription } from "@/lib/error";

/**
 * Turns a support code generated by a customer into run-as credentials for the current session.
 * On success the app reloads at its root so the impersonated session is picked up everywhere.
 */
export const RunAsSupportCodeForm = () => {
  const [supportCode, setSupportCode] = useState("");
  const [error, setError] = useState("");

  const { setRunAsCredentials } = restProvider();

  const runAs = async () => {
    setError("");
    try {
      const result = await setRunAsCredentials(supportCode.trim());
      if (result === "OK") {
        window.location.href = "/";
      } else {
        setError("The support code was not accepted. Ask the customer to generate a new one.");
      }
    } catch (e) {
      setError(
        oauth2ErrorDescription(e) ??
          (hasMessage(e) ? e.message : "The support code could not be checked. Try again."),
      );
    }
  };

  return (
    <form className="flex flex-col" onSubmit={(e) => e.preventDefault()}>
      <TextInput
        id="run-as-support-code"
        label="Support code"
        value={supportCode}
        onChange={(code) => setSupportCode(code ?? "")}
        placeholder="Paste the code generated by the customer"
        autoFocus
      />
      <ButtonLoader className="mt-4 self-end" onClick={runAs} disabled={!supportCode.trim()}>
        Run as
      </ButtonLoader>
      {error && <InlineError>{error}</InlineError>}
    </form>
  );
};
